import { Component, Input, OnInit, SimpleChange } from '@angular/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, SortDescriptor, State } from '@progress/kendo-data-query';
import { IProjectionsToActualsTabularListByPosition } from 'app/modules/performance/interfaces/performance-data';
import {
    NoDataActionType,
    NoDataSourceType,
    NoDataTypes,
} from 'app/modules/shared/interfaces/no-data';

@Component({
    selector: 'app-performance-actuals-vs-projections-table',
    templateUrl: './performance-actuals-vs-projections-table.component.html',
    styleUrls: ['./performance-actuals-vs-projections-table.component.scss'],
})
export class PerformanceActualsVsProjectionsTableComponent implements OnInit {
    loading: boolean;
    noDataType: NoDataTypes;
    noDataForCompany: boolean;
    hFilterJSON = '';
    unitTotal: number = 0;
    volTotal: number = 0;
    gridView: GridDataResult;
    skip = 0;
    pageSize = 5;
    sort: SortDescriptor[] = [];
    sortable = {
        mode: 'single',
        allowUnsort: true,
    };
    gridState: State = {
        sort: [],
        skip: 0,
        take: 5,
    };
    scrollable = 'scrollable';
    type: 'numeric' | 'input' = 'input';
    pageable = {
        refresh: true,
        info: true,
        type: this.type,
        previousNext: true,
        pageSizes: [5, 10, 20],
    };
    sumProjectionVolume: number;
    sumActualVolume: number;
    sumProjectionUnits: number;
    sumActualUnits: number;
    volumePctRatio: number;
    @Input() data: IProjectionsToActualsTabularListByPosition[];

    constructor() {}

    ngOnInit() {
        this.noDataType = {
            action: NoDataActionType.pageStart,
            searchTerm: '',
            componentTitle: 'Actuals vs Projections Table Summary',
            inputSource: NoDataSourceType.table,
            noDataCustomMessage: 'Add Projections to see data here.',
        };

        this.updateGrid();
    }

    setNoDataType(action: NoDataActionType) {
        this.noDataForCompany = true;
    }

    ngOnChanges(changes: { [property: string]: SimpleChange }) {
        let change: SimpleChange = changes['data'];
        if (change) {
            this.updateGrid();
        }
    }

    updateGrid() {
        if (this.data.length < 1) {
            this.noDataForCompany = true;
            this.loading = false;
            this.sumActualUnits = 0;
            this.sumActualVolume = 0;
            this.sumProjectionUnits = 0;
            this.sumProjectionVolume = 0;
            this.volumePctRatio = 0;
        } else {
            const aggregationUnit = this.data[0];
            this.sumActualUnits = aggregationUnit.sumActualUnits;
            this.sumActualVolume = aggregationUnit.sumActualVolume;
            this.sumProjectionUnits = aggregationUnit.sumProjectionUnits;
            this.sumProjectionVolume = aggregationUnit.sumProjectionVolume;
            this.volumePctRatio = aggregationUnit.volumePctRatio;
        }

        let orderedData = orderBy(this.data, this.sort).slice(this.skip, this.skip + this.pageSize);
        this.gridView = {
            data: orderedData,
            total: this.data.length,
        };
    }

    pageChange(event: PageChangeEvent): void {
        this.pageSize = event.take;
        this.skip = event.skip;
        this.updateGrid();
    }

    sortChange(sort: SortDescriptor[]): void {
        this.sort = sort;
        this.skip = 0;
        this.updateGrid();
    }
}
